module.exports = __webpack_public_path__ + "static/media/indicator.44101e4b.svg";